(function() {
    'use strict';

    angular.module('product')
        .controller('ProductParameterCreateController', ProductParameterCreateController);

    ProductParameterCreateController.$inject = ['$state', 'productParameterDataSrvc', 'notificationSrvc', 'productParameterMessagesConst', 'errorNotificationSrvc'];

    function ProductParameterCreateController($state, productParameterDataSrvc, notificationSrvc, productParameterMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            var_name: [],
            nonFieldErrors: []
        };
        self.productParameterData = {
            name_pl: '',
            name_en: '',
            name_de: '',
            name_cpde: '',
            name_cpen: '',
            var_name: ''
        };

        self.createProductParameter = createProductParameter;
        self.cleanErrors = cleanErrors;

        function createProductParameter() {
            productParameterDataSrvc.create(
                self.productParameterData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", productParameterMessagesConst.add);
                    $state.go('layout.productParameter.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
